import React from 'react';
import { RoyaltyCalculatorProvider } from '../../contexts/RoyaltyCalculatorProvider/RoyaltyCalculatorProvider.es.js';
import { RoyaltyCalculatorContent } from './components/RoyaltyCalculatorContent.es.js';

var RoyaltyCalculator = function RoyaltyCalculator() {
  return (
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorProvider, null,
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorContent, null))
  );
};

RoyaltyCalculator.displayName = 'RoyaltyCalculator';
export { RoyaltyCalculator };